import ApiClient from './ApiClient';

class AutomationRuleFoldersAPI extends ApiClient {
  constructor() {
    super('automation_rule_folders', { accountScoped: true });
  }

  updateOrder(data) {
    return window.axios.patch(`${this.url}/update_order`, { data });
  }
}

export default new AutomationRuleFoldersAPI();
